"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScenePresence = exports.SCENERY_GRACE_MS = void 0;
exports.sceneGround = sceneGround;
exports.SCENERY_GRACE_MS = 2000;
/** Per-scene deadlines bridge short gaps between qualifying objects. */
class ScenePresence {
    groundUntil = -Infinity;
    waterUntil = -Infinity;
    update(objects, now) {
        for (const object of objects) {
            if (object.apple?.exited)
                continue;
            if (object.finish === 'watermelon' || object.finish === 'apple' || object.finish === 'duck')
                this.groundUntil = now + exports.SCENERY_GRACE_MS;
            if (object.finish === 'duck' && !object.popped)
                this.waterUntil = now + exports.SCENERY_GRACE_MS;
        }
        const water = now < this.waterUntil;
        return { ground: water || now < this.groundUntil, water };
    }
    reset() { this.groundUntil = this.waterUntil = -Infinity; }
}
exports.ScenePresence = ScenePresence;
/** Keep the floor until the last watermelon fragment has finished its animation. */
function sceneGround(height, objects, retained = false) {
    const visible = retained || objects.some(object => object.finish === 'watermelon' || object.finish === 'apple' || object.finish === 'duck');
    const depth = visible ? Math.min(height, 72, Math.max(36, height * 0.08)) : 0;
    return { visible, y: Math.max(0, height - depth) };
}
//# sourceMappingURL=sceneGround.js.map